export default __webpack_public_path__ + "static/media/scholarship_bursaries_2023.b3ca8942.png";